<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<h3 class="ms-2 mt-2">Pianificazione fiscale</h3>

<div class="row mt-2 g-2 d-flex align-items-stretch">
  <div class="col-md-4 row-md-2">
    <!-- <mat-card class="mb-2 d-flex flex-column custom-card h-100">
      <div class="p-2 m-0 mt-0 flex-grow-1">
        <h5>Per l'anno {{nextYear}}:</h5>
      </div>
      <div>
        <mat-card class="mb-2 d-flex flex-column custom-card-pink">
          <div>
            <p><strong>Tasse:</strong>{{nextYearTotalAmountTasse }} €</p>
           </div>
        </mat-card>
        <mat-card class="mb-2 d-flex flex-column custom-card-pink">
          <div>
            <p><strong>Contributi:</strong>{{nextYearTotalAmountContributi }} €</p>
          </div>
        </mat-card>
      </div>
    </mat-card> -->
    <mat-card 
      class="h-100 custom-border-pink d-flex flex-column"
    >
      <mat-card-content class="p-0 m-2 flex-grow-1 d-flex flex-column">
        <div class="card-body p-0 d-flex flex-column flex-grow-1">
          <h5 class="card-title">Cosa dovrai pagare?</h5>
          <p>Per l'anno {{nextYear}}, secondo il simulatore, pagherai:</p>
          <div class="flex-grow-1 d-flex flex-column">
            <!-- Add align-items-center and justify-content-center here -->
            <mat-card class="clickable-pink custom-card-pink flex-grow-1 d-flex align-items-center justify-content-center" (click)="scrollToDettaglioMensile()">
              <mat-card-content class="p-0 m-1 w-100">
                <div class="d-flex m-0 justify-content-between align-items-center">
                  <p class="mt-2 mb-2 ms-2"><strong>Tasse: </strong>{{nextYearTotalAmountTasse }} €</p>
                  <mat-icon class="me-2">arrow_forward_ios</mat-icon>
                </div>
              </mat-card-content>
            </mat-card>
            
            <mat-card class="mt-2 clickable-pink custom-card-pink flex-grow-1 d-flex align-items-center justify-content-center" (click)="scrollToDettaglioMensile()">
              <mat-card-content class="p-0 m-1 w-100">
                <div class="d-flex m-0 justify-content-between align-items-center">
                  <p class="mt-2 mb-2 ms-2"><strong>Contributi: </strong>{{nextYearTotalAmountContributi }} €</p>
                  <mat-icon class="me-2">arrow_forward_ios</mat-icon>
                </div>
              </mat-card-content>
            </mat-card>

            <div class="d-flex m-0 justify-content-between align-items-center">
              <p class="mt-3">Sei iscritto a: <strong>{{ organization_data?.inps_fund_type }}</strong> </p>
              <span><button 
                mat-icon-button 
                class="ms-2 me-0" 
                (click)="openStatusInfoDialog()"
                matTooltip="Informazioni aggiuntive."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
                >
                <mat-icon>
                  info
                </mat-icon>
              </button></span>
            </div>

            <div class="d-flex m-0 justify-content-between align-items-center">
              <p class="text-small">Aliquota Imposta Sostitutiva: {{ getTaxRate(organization_data?.type) }}</p>
            </div>

          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="col-md-8 row-md-2">
    <mat-card class="mb-2 d-flex flex-column custom-border-pink h-100">
      <!-- <div class="p-2 m-0 mt-0 flex-grow-1">
          <h5>Prossimi eventi:</h5>
          <div *ngIf="nextThreeEvents.length > 0">
            <div class="d-flex flex-column gap-2">
              <mat-card 
                *ngFor="let event of nextThreeEvents" 
                class="clickable-yellow custom-card"
                >
                <div class="d-flex m-2 justify-content-between align-items-center">
                  <div class="d-flex flex-column"> 
                    <span>{{ event.type }}: {{ event.name }}</span>
                    <p class="m-0">Scadenza: {{ event.date | date:'dd/MM/yyyy' }}</p>
                  </div>
                  <span class="fw-bold">{{ event.amount }} €</span>
                </div>
              </mat-card>
            </div>
          </div>
          <div *ngIf="nextThreeEvents.length === 0">
            <p>Nessun evento prossimamente.</p>
          </div>
        </div> -->
      <mat-card-content class="p-3">
        <h5 class="mb-3">Andamento tasse nei prossimi 2 anni</h5>
        <p class="text-muted text-small">Seleziona un anno in basso per iniziare</p>
        <div>
          <div *ngIf="!isLoading" class="chart-container">
            <canvas baseChart
                    [data]="lineChartData"
                    [options]="lineChartOptions"
                    [type]="lineChartType">
            </canvas>
          </div>

          <div *ngIf="isLoading" class="text-center p-4">
            <mat-spinner></mat-spinner>
            <p>Caricamento grafico...</p>
          </div>
        </div>
        <!-- <p>Grafico che mostra l'andamento delle tasse mese per mese per l'anno corrente e il prossimo anno.</p> -->
      </mat-card-content>
    </mat-card>
  </div>
</div>

<h4 class="mt-3" #dettaglioMensile>Dettaglio mensile</h4>

<mat-card class="mb-3 col-md-12 d-flex flex-column custom-border-pink">
    <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center mb-0 mt-3 me-2 ms-2">
      <mat-form-field appearance="outline" class="mt-0 w-sm-25">
        <mat-label>Seleziona Anno</mat-label>
        <mat-select [(value)]="selectedYear" (selectionChange)="bothTaxableComputationAndYearChange()">
          <mat-option *ngFor="let year of availableYears" [value]="year">
            {{ year }}
          </mat-option>
        </mat-select>
      </mat-form-field>

    <div class="mt-0 w-sm-25"></div>
    <div class="mt-0 w-sm-25"></div>
      
      <button
          mat-raised-button
          class="mt-0 mb-3 w-sm-25 pink-button"
          (click)="openNewFiscalEventDialog()"
        >
          <mat-icon>add</mat-icon>
          Carica eventi fiscali
      </button>
    </div>

    <div class="ms-3 me-3">
      <div class="d-flex align-items-center">
        <p class="mb-0 hidden-mobile">
          <strong>Fatturato incassato del {{selectedYear}}:</strong> € {{taxableAmount | number:'1.2-2'}} 
        </p>
        <button
          mat-icon-button 
          class="ms-1 mb-1 hidden-mobile" 
          (click)="handleAmountInfoClick($event)"
          matTooltip="Informazioni aggiuntive sul fatturato."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
        >
          <mat-icon>info</mat-icon>
        </button>

      </div>
      <p class="hidden-mobile"><strong>Incidenza tasse ({{selectedYear+1}}):</strong> {{formatIncidence(yearTaxIncidence)}}</p>
      <p class="hidden-mobile"><strong>Incidenza contributi ({{selectedYear+1}}):</strong> {{formatIncidence(yearContributiIncidence)}}</p>
      <!-- mobile version -->
      <div class="mt-2 visible-mobile d-flex justify-content-between align-items-center">
        <span class="text-small text-right"><strong>Fatturato incassato del {{selectedYear}}: </strong></span>
        <div class="d-flex align-items-center">
          <button
          mat-icon-button 
          class="ms-1 mb-1" 
          (click)="handleAmountInfoClick($event)"
          matTooltip="Informazioni aggiuntive sul fatturato."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
        >
          <mat-icon>info</mat-icon>
        </button>
          <span class="text-small text-left">€ {{taxableAmount | number:'1.2-2'}}</span>
        </div>
      </div>
      <div class="mt-2 visible-mobile d-flex justify-content-between align-items-center">
        <span class="text-small text-right"><strong>Incidenza tasse ({{selectedYear+1}}): </strong></span>
        <span class="text-small text-left">{{formatIncidence(yearTaxIncidence)}}</span>
      </div>
      <div class="mt-2 mb-3 visible-mobile d-flex justify-content-between align-items-center">
        <span class="text-small text-right"><strong>Incidenza contributi ({{selectedYear+1}}): </strong></span>
        <span class="text-small text-left">{{formatIncidence(yearContributiIncidence)}}</span>
      </div>
    </div>
</mat-card>

<ng-template #amountInfoDialog let-dialogRef="dialogRef">
  <h2 mat-dialog-title class="m-0 pt-3 ps-3 d-flex align-items-center">
    <mat-icon class="me-2">info</mat-icon> 
    Dettagli Fatturato
  </h2>
  
  <mat-dialog-content class="pt-3">
    <p class="mb-2">
      Il <strong>totale fatturato</strong> rappresenta la somma di tutte le fatture emesse nell'anno selezionato, 
      al netto delle eventuali note di credito registrate.
    </p>
    <p class="mb-0">
      Se la <strong>cassa previdenziale</strong> alla quale appartieni non è l'INPS (nel tuo caso è {{getFundName(organization_data?.favorite_pension_fund)}}), potresti vedere un valore diverso rispetto al totale delle fatture. Questo perchè la percentuale di Rivalsa o Cassa previdenziale, in questo caso, non produce reddito.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="pb-3 pe-3">
    <button mat-raised-button (click)="dialogRef.close()">
      <mat-icon>check</mat-icon>
      Ok, capito
    </button>
  </mat-dialog-actions>
</ng-template>

<!-- TODO: add coefficiente redditività -->
<!-- <mat-card class="mb-3 hidden-mobile custom-card-pink">
  <div class="w-100 d-flex mt-2 mb-0 justify-content-between align-items-center">
    <h6 class="ms-3">Reddito imponibile {{ selectedYear }}:</h6>
    <span class="me-3"> 
      <h6> 
        <strong>€{{ taxableAmount | number:'1.2-2' }}</strong>
      </h6> 
    </span>
  </div>
</mat-card> -->

<div class="expansion-panels-container">
  <mat-accordion class="expansion-headers-align" multi>
    <mat-expansion-panel *ngFor="let month of months; let i = index" 
                         [expanded]="isPanelExpanded(i)">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <p class="hidden-mobile mt-3">{{ month }}</p>
          <p class="text-small visible-mobile mt-3">{{ month }}</p>
        </mat-panel-title>

        <mat-panel-description>
          <p class="hidden-mobile mt-3">Totale: {{ getMonthTotal(i, selectedYear) | currency:'EUR' }}</p>
          <p class="text-small visible-mobile mt-3">Totale: {{ getMonthTotal(i, selectedYear) | currency:'EUR' }}</p>
          <span class="event-count-badge hidden-mobile" *ngIf="getMonthEvents(i, selectedYear).length > 0">
            {{ getMonthEvents(i, selectedYear).length }} evento/i
          </span>
          <span class="event-count-badge visible-mobile mt-2" *ngIf="getMonthEvents(i, selectedYear).length > 0">
            {{ getMonthEvents(i, selectedYear).length }}
          </span>
        </mat-panel-description>

      </mat-expansion-panel-header>

      <div *ngIf="getMonthEvents(i, selectedYear).length > 0; else noEvents">
        <div *ngIf="getMonthEvents(i, selectedYear).length > 0; else noEvents">
  <mat-list dense>
    <mat-list-item *ngFor="let event of getMonthEvents(i, selectedYear)" class="event-item">
      <div class="event-name">
        <strong>{{ event.type }}</strong>: {{ event.name }}
      </div>
      <div mat-line class="event-details">
        Scadenza: {{ event.date | date:'dd/MM/yyyy' }} - Importo: 
        <strong [ngClass]="{'text-green': event.is_credit}">
          {{ event.is_credit ? '(' : '' }}{{ event.amount | currency:'EUR' }}{{ event.is_credit ? ')' : '' }}
        </strong>
      </div>
      
      <!-- Single event-actions div with responsive classes inside -->
      <div class="event-actions d-flex align-items-center flex-wrap">
        <!-- Button always visible -->
        <button mat-button (click)="openEventeDetail(event)" class="me-3 warn-button">
          <mat-icon>help</mat-icon> 
          Dettagli
        </button>

        <!-- Delete button - hidden on mobile, visible on desktop -->
        <button 
          *ngIf="event.is_created_by_user === true" 
          mat-button 
          (click)="softDeleteEvent(event)" 
          class="me-3 warn-button hidden-mobile"
        >
          <mat-icon>delete</mat-icon> 
          Elimina
        </button>
        
        <!-- Checkbox and status - always visible -->
        <div 
          *ngIf="event.is_credit === false"
          class="d-flex align-items-center me-3"
        >
          <mat-checkbox
            [(ngModel)]="event.is_paid"
            (change)="togglePaidStatus(event)"
            (click)="$event.stopPropagation()"
            class="me-2 custom-checkbox"
          >
          </mat-checkbox>
          <span class="text-small">{{event.is_paid ? 'Saldato' : 'Non saldato'}}</span>
        </div>

        <!-- User-created chip - hidden on mobile, visible on desktop -->
        <div *ngIf="event.is_created_by_user === true" class="hidden-mobile">
          <mat-chip>
            Creato dall'utente
          </mat-chip>
        </div>

        <!-- Mobile-only section for delete and chip -->
        <div class="visible-mobile d-flex align-items-center">
          <button 
            *ngIf="event.is_created_by_user === true" 
            mat-button 
            (click)="softDeleteEvent(event)" 
            class="me-3 warn-button"
          >
            <mat-icon>delete</mat-icon> 
            Elimina
          </button>
          
          <div *ngIf="event.is_created_by_user === true">
            <mat-chip>
              Creato dall'utente
            </mat-chip>
          </div>
        </div>
      </div>

      <mat-divider class="custom-divider"></mat-divider>
    </mat-list-item>
  </mat-list>
</div>
      </div>
      
      <ng-template #noEvents>
        <p class="no-events-message">Nessun evento fiscale per questo mese</p>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<div class="pt-3 mb-3"></div>

<!-- <mat-divider></mat-divider> -->

<!-- TODO: print fiscal plan -->
<!-- <div class="d-flex flex-column">
  <div class="mt-3 mb-3 d-flex align-self-end">
    <button
        mat-raised-button
        color="primary"
        class="ms-3"
      >
        <mat-icon>print</mat-icon>
        Stampa piano fiscale
    </button>
  </div>
</div> -->


<!-- Calendario -->
<!-- <h4>Calendario:</h4>

<div class="mb-3 row">
  <app-calendar-component></app-calendar-component>
</div> -->
